"use client";
import { useFeatureNavigation } from "./use-feature-navigation";

export function useSearchParams(): URLSearchParams {
  return new URLSearchParams(useFeatureNavigation().search);
}
